(function (Reviews, $, undefined) {
  var $buildStars = $('.js-build-stars'),
      yotpoSeeder = window.location.hostname.indexOf('binoculars') > 0 ? 'yotpo-seeder-celestron':'yotpo-seeder-telescopes';

  Reviews.getHTML = function(averageRating) {
    var html = '';
    for(var i = 0; i < 5; i++) {
      if(averageRating >= 1) {
        html += '<i class="fa fa-star" aria-hidden="true"></i>';
      } else if (averageRating > 0){
        html += '<i class="fa fa-star-half-o" aria-hidden="true"></i>';
      } else {
        html += '<i class="fa fa-star-o" aria-hidden="true"></i>';
      }
      averageRating--;
    }
    return html;
  };

 Reviews.setImages = function() {

   if(productImages.length > 0) {
     for (var i = 0; i < productImages.length; i++) {
        $('.rating-photos .js-slick').append('<div id="' + productImages[i].review + '" class="single-image"><a href="'+productImages[i].img+'" data-gall="customerUploads"><img src="'+productImages[i].img+'" /></a></div>');
     }
     $('.rating-photos .js-slick').after('<a href="" class="view-gallery">View Image Gallery</a>');
     $('.rating-photos').show().find('div a').venobox();
     $('.view-gallery').on('click',function(){
       $('.rating-photos a:eq(0)').trigger('click');
       return false;
     });
     if(IsMobile.check()) {
       $('.rating-photos').find('.js-slick').slick({
         arrows:true,
         nextArrow:'<button type="button" class="nav-white nav-next"><i class="fa fa-angle-right" aria-hidden="true"></i><button>',
         prevArrow:'<button type="button" class="nav-white nav-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
         slidesToScroll: 3,
         variableWidth: true,
         mobileFirst: true,
         infinite:false,
         responsive:[
           {
             breakpoint: 1024,
             settings: 'unslick'
           }
         ]
       });
     }
   }
 };

 Reviews.build = function() {
   var $buildStars = $('.js-build-stars');
   for(var i = 0, length = $buildStars.length; i < length; i++) {
     var $curr = $buildStars.eq(i);
     $curr.html(Reviews.getHTML($curr.data('average')));
   }
 };

  var bindUIActions = function () {
    $('.js-write-review').click(function(){
      $('#yotpo-override-review').find('.write-review-button').trigger('click');
      return false;
    });
  };

  Reviews.init = function () {
    bindUIActions();
    Reviews.build();
  };

}(window.Reviews = window.Reviews || {}, jQuery));
